module.exports = __webpack_public_path__ + "media/images/feature/Conference-amico-93126a7fd9be86e92ba5a334bc89a865.png";